import {useEffect, useMemo, useState} from 'react'
import headers from '../../../../configs/allProspectsTableHeader.json'
import {useDispatch, useSelector} from 'react-redux'
import {count} from '../../../../store/prospectSegment/allProspectsCount/allProspectsCountSlice'
import {
  addColumn,
  getAllColumns,
  getDefaultColumns
} from '../../../../store/prospectSegment/addTableColumn/addTableColumnSlice'
import useUserPreferenceProspectsColumn from '../../../../api/getUserPreferencesProspectColumns'
import useProspectsList from '../../../../api/getProspectList'
import {
  getAllProspectsData,
  getAllSavedProspectsData
} from '../../../../store/prospectSegment/allProspectsData/allProspectsDataSlice'
import TableComponent from '../../../Common/TableComponent/TableComponentIndex'
import {setResetSearchTerm, updatedAllProspectsSearchTerm} from '../../../../store/search/searchSlice'
import {getProspectsPageNumber, getSavedProspectsPageNumber} from '../../../../store/pagination/pageNumberSlice'
import prospectsActions from '../../../../configs/prospectsAction.json'
import {constituentIdList} from '../../../../store/prospectSegment/savedProspectsList/saveProspectsListSlice'
import {selectedTab} from '../../../../store/prospectSegment/selectedProspectsTab/selectedProspectsTabSlice'
import {StyledAlert, StyledBox, StyledSaveAndGenerateButton} from '../Styles'
import SearchPanel from '../../../Common/SearchPanel/SearchPanelIndex'
import SaveList from '../SaveList/SaveListIndex'
import AddColumn from '../../../Common/AddColumn'
import paginationLimit from '../../../../configs/paginationLimit.json'
import {setCampaignView} from '../../../../store/selectedView/campaignView/campaignViewIndex'
import {Menu, MenuItem} from '@mui/material'
import {setCampaignAction} from '../../../../store/selectedView/campaignView/campaignActionSlice'
import {setAllConstituentsFilters} from '../../../../store/prospectSegment/openSavedProspect/openSavedProspectSlice'
import PropTypes from 'prop-types'
import {setFilters} from '../../../../store/askGivePrism/askGivePrismSlice'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import {getClassYear, getUniqueCollegeAndDegree} from './helpers'
import ExportListIndex from './ExportList/ExportListIndex'
import {setAddToSavedProspects} from '../../../../store/prospectSegment/addToSavedProspects/addToSavedProspectsSlice'

const selectSearchTerm = [
  {contentKey: 'savedProspects', selectorContent: 'savedProspectsSearch'},
  {contentKey: 'allProspects', selectorContent: 'allProspectsSearch'}
]

const AllProspects = ({height}) => {
  const defaultHeaders = useSelector((state) => state.addColumnProspectsTable.defaultValue)
  const data = useSelector((state) => state.getAllProspectsData.prospectList)
  const dispatch = useDispatch()
  const [conditionalHeaders, {data: headersData, loading: headersLoading, error: headersError}] =
    useUserPreferenceProspectsColumn()

  const currentSelectedTab = useSelector((state) => state.selectedProspectTab.value)
  const searchTermSelector = selectSearchTerm.find((item) => item.contentKey === currentSelectedTab)
  const searchString = useSelector((state) => state.search[searchTermSelector.selectorContent])
  const {previousTerm, currentTerm} = searchString
  const [conditionalProspectList, {data: prospectsListData, loading: prospectsListLoading, error: prospectsListError}] =
    useProspectsList()

  const totalCount = useSelector((state) => state.totalProspectsCount.value)
  const allProspectsColumns = useSelector((state) => state.addColumnProspectsTable.prospectListColumn)
  const currentHeaders = useSelector((state) => state.addColumnProspectsTable.defaultValue)

  const showCheckboxes = prospectsActions.allProspects.checkBoxRequired
  const showAddColumnHeader = prospectsActions.allProspects.addColumnRequired
  const selectedItemCurrentPageNumber = useSelector((state) => state.currentPageNumber.value)
  const selectedSavedProspectPageNumber = useSelector((state) => state.currentPageNumber.savedProspectsValue)
  const hasAccordian = prospectsActions.allProspects.hasAccordian
  const [rowData, setRowData] = useState()
  const [selectAll, setSelectAll] = useState(false)
  const askGivePrismFilters = useSelector((state) => state.askGivePrism.filters)
  const constituentsList = useSelector((state) => state.saveProspectList.value)
  const showSaveList = prospectsActions.allProspects.saveListRequired
  const [isActionRequired, setIsActionRequired] = useState(prospectsActions.allProspects.hasActions)
  const actionMenu = prospectsActions.allProspects.actionsMenu
  const hasMainPrompt = useSelector((state) => state.chatBotSlice.message)
  const superUser = useSelector((state) => state.superUserTenantSlice.isSuperUser)
  const azureRole = useSelector((state) => state.superUserTenantSlice.azureRole)
  const isTenantDataLoading = useSelector((state) => state.superUserTenantSlice.isTenantDataLoading)
  const isTenantDataError = useSelector((state) => state.superUserTenantSlice.isTenantDataError)
  const refData = useSelector((state) => state.opportunityBank.refData)
  const resetSearchTerm = useSelector((state) => state.search.resetSearchTerm)
  const [disableButton, setDisableButton] = useState(false)

  useEffect(() => {
    if (resetSearchTerm) {
      setSearchTerm('')
      dispatch(setResetSearchTerm(false))
      setSelectAll(false)
    }
  }, [resetSearchTerm, dispatch])

  useEffect(() => {
    if (!hasMainPrompt) {
      dispatch(constituentIdList([]))
      dispatch(getProspectsPageNumber(1))
      if (Object.keys(askGivePrismFilters).length === 0) {
        dispatch(getAllProspectsData([]))
        dispatch(setFilters({}))
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (superUser && !azureRole) {
      return
    }
    if (defaultHeaders?.length === 0) {
      conditionalHeaders()
    }
  }, [defaultHeaders, conditionalHeaders, superUser, azureRole])

  const defaultColumnCheck = () => {
    const mandatoryColumns = headers.mandatoryColumn.filter(
      (element) => !headersData?.getUserPreferences[0]?.defaultColumns.includes(element)
    )
    const updatedColumns = [...(headersData?.getUserPreferences[0]?.defaultColumns || []), ...mandatoryColumns]
    dispatch(getDefaultColumns(updatedColumns))
  }

  useEffect(() => {
    if (headersData?.getUserPreferences != null && headersData.getUserPreferences[0]?.defaultColumns.length > 0) {
      defaultColumnCheck()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headersData, conditionalProspectList, dispatch])

  useEffect(() => {
    if (superUser && !azureRole) {
      return
    }
    if (data?.prospects?.length === 0 && defaultHeaders.length > 0) {
      conditionalProspectList()
    }
  }, [data, defaultHeaders, conditionalProspectList, superUser, azureRole])

  const [resetFlag, setResetFlag] = useState(false)
  useEffect(() => {
    if (Object.keys(askGivePrismFilters).length > 0) {
      dispatch(getAllProspectsData([]))
      setResetFlag(true)
      dispatch(getProspectsPageNumber(1))
      dispatch(constituentIdList([]))
    }
  }, [askGivePrismFilters, dispatch])

  useEffect(() => {
    if (prospectsListData?.prospectList?.prospects?.length >= 0) {
      dispatch(getAllProspectsData(prospectsListData.prospectList.prospects))
      dispatch(count(prospectsListData.prospectList.totalCount))
      dispatch(
        getAllColumns([
          ...Object.keys(prospectsListData?.prospectList?.prospects[0]).filter(
            (key) => !headers.excludedFromAddColumns.includes(key)
          ),
          ...headers.additionalColumns
        ])
      )
    }
  }, [prospectsListData, dispatch, prospectsListError])

  useMemo(() => {
    if (previousTerm !== currentTerm) {
      dispatch(getProspectsPageNumber(1))
      conditionalProspectList()
    }
  }, [conditionalProspectList, currentTerm, previousTerm, dispatch])

  useEffect(() => {
    if (data?.prospects?.length > 0) {
      const updatedRows = data?.prospects.map((row) => ({
        ...row,
        selected: constituentsList.includes(row.uniqueConstituentIdentifier),
        classYear: getClassYear(row.educationSummary),
        college: getUniqueCollegeAndDegree(row.educationSummary, 'college'),
        degree: getUniqueCollegeAndDegree(row.educationSummary, 'degree')
      }))
      setRowData(updatedRows)
      const allSelected = updatedRows.length > 0 && updatedRows.every((row) => row.selected)
      setSelectAll(allSelected)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, data])

  useEffect(() => {
    setDisableButton(
      headersLoading ||
        prospectsListLoading ||
        isTenantDataLoading ||
        headersError ||
        prospectsListError ||
        isTenantDataError
    )
  }, [headersLoading, prospectsListLoading, isTenantDataLoading, headersError, prospectsListError, isTenantDataError])

  const handleChangePage = (event, newValue) => {
    if (newValue !== selectedItemCurrentPageNumber) {
      dispatch(getAllProspectsData([]))
      dispatch(getProspectsPageNumber(newValue))
      setSelectAll(false)
      setResetFlag(true)
    }
  }

  const handleSelectAll = (event) => {
    const checked = event.target.checked
    const updatedRows = rowData?.map((row) => ({...row, selected: checked}))
    setSelectAll(checked)
    setRowData(updatedRows)
    const currentPageIds = updatedRows.map((row) => row.uniqueConstituentIdentifier)
    const updatedList = checked
      ? [...new Set([...constituentsList, ...currentPageIds])]
      : constituentsList.filter((id) => !currentPageIds.includes(id))
    dispatch(constituentIdList(updatedList))
    setIsActionRequired(!checked)
  }

  const handleRowCheckboxChange = (event, obj) => {
    const checked = event.target.checked
    const updatedRows = rowData.map((row) =>
      row.uniqueConstituentIdentifier === obj.uniqueConstituentIdentifier ? {...row, selected: checked} : row
    )
    setRowData(updatedRows)
    const allSelected = updatedRows.every((row) => row.selected)
    const anySelected = updatedRows.some((row) => row.selected)
    setSelectAll(allSelected)
    const updatedList = checked
      ? [...new Set([...constituentsList, obj.uniqueConstituentIdentifier])]
      : constituentsList.filter((id) => id !== obj.uniqueConstituentIdentifier)
    dispatch(constituentIdList(updatedList))
    setIsActionRequired(!anySelected)
  }

  const [isSavingSuccess, setIsSavingSuccess] = useState(false)

  const [searchTerm, setSearchTerm] = useState('')
  const [openDialog, setOpenDialog] = useState(false)

  const handleOpenDialog = () => {
    setOpenDialog(true)
  }

  useEffect(() => {
    if (isSavingSuccess) {
      setOpenDialog(false)
      setIsSavingSuccess(false)
      dispatch(constituentIdList([]))
      dispatch(getAllSavedProspectsData([]))
      dispatch(getSavedProspectsPageNumber(1))
      if (currentTerm !== previousTerm) {
        dispatch(getAllProspectsData([]))
        dispatch(getProspectsPageNumber(1))
      }
      dispatch(selectedTab('savedProspects'))
      dispatch(updatedAllProspectsSearchTerm({currentTerm: '', previousTerm: ''}))
    }
  }, [dispatch, isSavingSuccess, currentTerm, previousTerm])

  const dispatchProspectsSetSearchTerm = (searchTerm) => {
    setSearchTerm(searchTerm)
    dispatch(updatedAllProspectsSearchTerm({currentTerm: searchTerm, previousTerm: currentTerm}))
  }

  const saveMenuOptions = [
    {label: 'New list', key: 'newList'},
    {label: 'Saved list', key: 'savedList'}
  ]

  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleSaveToBtnClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleSavedListClick = (selectedItem) => {
    if (selectedItem === 'savedList') {
      dispatch(setAddToSavedProspects([]))
      dispatch(constituentIdList(constituentsList))
      dispatch(setCampaignView('addToSavedList'))
      dispatch(setCampaignAction('addToSavedList'))
      if (selectedSavedProspectPageNumber !== 1) {
        dispatch(getAllSavedProspectsData([]))
        dispatch(getSavedProspectsPageNumber(1))
      }
      dispatch(selectedTab('savedProspects'))
      dispatch(
        setAllConstituentsFilters({
          searchTerm: ''
        })
      )
      if (currentTerm !== previousTerm && currentSelectedTab === 'allProspects') {
        dispatch(getAllProspectsData([]))
        dispatch(getProspectsPageNumber(1))
        dispatch(updatedAllProspectsSearchTerm({currentTerm: '', previousTerm: currentTerm}))
      }
    } else {
      handleOpenDialog()
    }
  }
  const handleSort = () => {
    dispatch(getAllProspectsData([]))
  }

  const deselectAll = () => {
    setSelectAll(false)
    const updatedRows = rowData?.map((row) => ({...row, selected: false}))
    setRowData(updatedRows)
    dispatch(constituentIdList([]))
    setIsActionRequired(true)
  }

  return (
    <>
      {hasMainPrompt && (
        <StyledAlert icon={<ErrorOutlineIcon fontSize="inherit" />} severity="info">
          The table below was filtered based on the GenAI responses from the chatbot. Please review to confirm accuracy.
        </StyledAlert>
      )}
      <StyledBox>
        <SearchPanel
          width="35%"
          aria-label="search-for-a-user"
          data-testid="search-panel"
          searchTerm={searchTerm}
          setSearchTerm={dispatchProspectsSetSearchTerm}
          placeholder="Search for a name"
        />
        {constituentsList.length > 0 && (
          <StyledSaveAndGenerateButton variant="outlined" onClick={deselectAll} disabled={disableButton}>
            {`Deselect (${constituentsList.length})`}
          </StyledSaveAndGenerateButton>
        )}
        {showSaveList && (
          <>
            <StyledSaveAndGenerateButton
              variant="outlined"
              onClick={handleSaveToBtnClick}
              disabled={!constituentsList.length}
            >
              {constituentsList.length > 0 ? `+ Add (${constituentsList.length}) to` : `+ Add to`}
            </StyledSaveAndGenerateButton>
            <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose} onClick={handleMenuClose}>
              {saveMenuOptions.map((option) => (
                <MenuItem key={option.key} onClick={() => handleSavedListClick(option.key)} dense>
                  {option.label}
                </MenuItem>
              ))}
            </Menu>
          </>
        )}
        <ExportListIndex
          disableExport={disableButton}
          searchTerm={searchTerm}
          count={totalCount}
          constituentsList={constituentsList}
          documentName={`Prospects_${new Date().toISOString()}`}
        />
      </StyledBox>
      <TableComponent
        height={height}
        loading={headersLoading || prospectsListLoading || isTenantDataLoading}
        error={headersError || prospectsListError || isTenantDataError}
        headers={defaultHeaders}
        explicitKeyLabelMapping={headers.explicitKeyLabelMapping}
        data={data?.prospects}
        showCheckboxes={showCheckboxes}
        showAddColumnHeader={showAddColumnHeader}
        addColumnComponent={
          <AddColumn
            columns={allProspectsColumns}
            currentHeaders={currentHeaders}
            shouldSavePreferences={true}
            handleMenuItemClick={(data) => dispatch(addColumn(data))}
          />
        }
        actionMenuList={actionMenu}
        selectedItemCurrentPageNumber={selectedItemCurrentPageNumber}
        totalCount={totalCount}
        handleChangePage={handleChangePage}
        hasAccordian={hasAccordian}
        isActionRequired={isActionRequired}
        handleSelectAll={handleSelectAll}
        handleRowCheckboxChange={handleRowCheckboxChange}
        rowData={rowData}
        setRowData={setRowData}
        selectAll={selectAll}
        rows={paginationLimit.pagination.prospectsSegment}
        currentTab={'allProspects'}
        resetFlag={resetFlag}
        setResetFlag={setResetFlag}
        prospectList={rowData}
        searchTerm={searchTerm}
        statesValue={refData?.find((item) => item.filter === 'state')?.valuesWithId || []}
        excludedSorting={headers.excludedSorting}
        handleDataSort={handleSort}
      />
      {openDialog && (
        <SaveList open={openDialog} setOpenDialog={setOpenDialog} setIsSavingSuccess={setIsSavingSuccess} />
      )}
    </>
  )
}

AllProspects.propTypes = {
  height: PropTypes.number
}

export default AllProspects
